var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45453 6.63635C5.0064 6.63635 4.63635 7.0064 4.63635 7.45453V17.2726C4.63635 17.7208 5.0064 18.0908 5.45453 18.0908H18.5453C18.9935 18.0908 19.3635 17.7208 19.3635 17.2726V7.45453C19.3635 7.0064 18.9935 6.63635 18.5453 6.63635H5.45453ZM3 7.45453C3 6.10267 4.10267 5 5.45453 5H18.5453C19.8972 5 20.9999 6.10267 20.9999 7.45453V17.2726C20.9999 18.6245 19.8972 19.7272 18.5453 19.7272H5.45453C4.10267 19.7272 3 18.6245 3 17.2726V7.45453Z",
    fill: "#3A4555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14797 6.98528C3.4071 6.6151 3.91726 6.52507 4.28744 6.7842L12 12.183L19.7126 6.7842C20.0827 6.52507 20.5929 6.6151 20.852 6.98528C21.1112 7.35547 21.0211 7.86562 20.6509 8.12475L12.4692 13.852C12.1875 14.0492 11.8125 14.0492 11.5308 13.852L3.34905 8.12475C2.97887 7.86562 2.88884 7.35547 3.14797 6.98528Z",
    fill: "#3A4555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.cd7fc7b3ae112f8e55ad2b8d0a0267ab.svg";
export { ForwardRef as ReactComponent };